import React, { Component } from "react"
import { translate } from "react-i18next"
import styled from "styled-components"
import PropTypes from "prop-types"

const FilterGroupContainer = styled.div``
const ExpandableFilterGroupContainer = FilterGroupContainer.extend`
  margin-top: 20px;
`

const FilterGroupHeading = styled.h3`
  float: left;
  font-weight: normal;
  font-size: 14px;
  cursor: pointer;
  text-transform: uppercase;
  color: #b3b3b3;
  &::selection {
    background: transparent;
  }
`

const FilterGroupToggle = styled.button`
  float: right;
  padding: 4px !important;
  width: 24px !important;
  height: 24px !important;
  line-height: 16px !important;
  font-size: 8px !important;
  border: 0 !important;
`

class FilterGroup extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    expandable: PropTypes.bool,
    expanded: PropTypes.bool,
    titleTextKey: PropTypes.string,
    onToggleExpand: PropTypes.func,
    children: PropTypes.node,
  }

  static defaultProps = {
    expandable: false,
    expanded: false,
    titleTextKey: null,
    onToggleExpand: null,
    children: null,
  }

  render() {
    const {
      t, expandable, expanded, titleTextKey, onToggleExpand, children,
    } = this.props

    if (expandable) {
      return (
        <ExpandableFilterGroupContainer>
          {titleTextKey && (
            <div>
              <FilterGroupHeading onClick={onToggleExpand}>{t(titleTextKey)}</FilterGroupHeading>
              <FilterGroupToggle
                className="btn btn-circle btn-secondary btn-xs"
                onClick={onToggleExpand}
              >
                <i className={`fa fa-chevron-${expanded ? "up" : "down"}`} />
              </FilterGroupToggle>
              <div className="clearfix" />
            </div>
          )}
          {(!expandable || expanded) && this.props.children}
        </ExpandableFilterGroupContainer>
      )
    }

    return <FilterGroupContainer>{children}</FilterGroupContainer>
  }
}

export default translate()(FilterGroup)



// WEBPACK FOOTER //
// ./src/components/filters/FilterGroup.jsx